import { useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { useDeleteAccountsPayableMutation } from '../../services/accountsPayableApi';
export function useDeleteAccountsPayable() {
    const { t } = useTranslation();
    const [trigger] = useDeleteAccountsPayableMutation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [successDeleteAccountsPayableMessage, setSuccessDeleteAccountsPayableMessage] = useState();
    async function deleteAccountsPayable(id) {
        setError(undefined);
        setSuccessDeleteAccountsPayableMessage(undefined);
        setLoading(true);
        try {
            const { data, error } = await trigger({ id });
            if (error) {
                setError(t('accounts-payable.delete-modal-error-message'));
                return;
            }
            if (data) {
                setSuccessDeleteAccountsPayableMessage(t('accounts-payable.delete-success-message'));
                return;
            }
        }
        catch {
            setError(t('accounts-payable.delete-modal-error-message'));
            return;
        }
        finally {
            setLoading(false);
        }
    }
    return {
        error,
        loading,
        successDeleteAccountsPayableMessage,
        deleteAccountsPayable,
        setLoading,
        setError,
        setSuccessDeleteAccountsPayableMessage,
    };
}
